import React from 'react';

import { MapTo } from '@adobe/aem-react-editable-components';

import './ContactDetails.sass';

export const ContactDetails = () => <div>ContactDetails</div>;

ContactDetails.displayName = 'ContactDetails';

ContactDetails.propTypes = {};

ContactDetails.defaultProps = {};

MapTo(['e-fix/components/content/contactdetails'])(ContactDetails);
